import API from '@services/API';
import axios from 'axios';

const DocumentoEnvioService = {

  getDe : async (id) => await axios.get(`/de/${id}`),
  getSegundaViaDe : async (processo,codigoInep) => await API.download(`/de/copia/${processo}/${codigoInep}`),
  filtrar: async (processo, filters) => await API.filters(`${processo}/escolas/des/filtrar`, filters),
  atualizarStatusDiscrepancia: async (processo,id, obj) => await API.put(`${processo}/des/${id}/tratarDiscrepancia`, obj),

}

export default DocumentoEnvioService;
